let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aS6fq")).then(() => parcelRequire('6MRTm'));